const API_URL = "https://tictactoe-ws.ntgarage.com/";
//const API_URL = "http://localhost:4000";
//http://localhost:4000

export default API_URL;
